function FetchService(url, method, payload){
        const token = JSON.parse(window.localStorage.getItem("okta-token-storage")).accessToken.accessToken;

        if(method === "GET"){
            return fetch(url, {method: method,mode: 'cors',headers: {Authorization: `Bearer ${token} `,'Content-Type': 'application/json'},})
        }if(method === "POST"){
            return fetch(url, {method: method,mode: 'cors',body: payload, headers: {Authorization: `Bearer ${token} `,'Content-Type': 'application/json'},})
        }
}
export{ FetchService };